$(document).ready(function () {
	// Lazyload
	$("img.lazyload").lazyload();

	// // busca	
    let buscaTimeout;

	$('.input-busca, .btn-busca, .input-busca-component')
	.focus(function () {
		clearTimeout(buscaTimeout);
		$(this).parent().parent().addClass('busca-ativa');
	})
	.blur(function () {
		const $parent = $(this).parent().parent();

		buscaTimeout = setTimeout(function () {
			$parent.removeClass('busca-ativa');
			$('.ctn-result-busca').hide();
		}, 500);
	});
	
	// Animation for the languages and currency dropdown
	$('.switcher').hover(function() {
		$(this).find('.option').stop(true, true).slideDown(300);
	},function() {
		$(this).find('.option').stop(true, true).slideUp(150);
	}); 
	
	// Carrinho
	$('#cart-trigger').click(function() {
		$('.cart').toggleClass('open-sidebox');
		$('.backdrop').toggleClass('open-backdrop');
	});
	
	closeCart = function(){	
		$('.cart').removeClass('open-sidebox');
		$('.backdrop').removeClass('open-backdrop');
	}

	// Central de ajuda
	$('#callTrigger').click(function() {
		$('.call-sidebox').toggleClass('open-sidebox');
		$('.backdrop').toggleClass('open-backdrop');
	});
	
	closeCall = function(){	
		$('.call-sidebox').removeClass('open-sidebox');
		$('.backdrop').removeClass('open-backdrop');
	}

	// Central do usuário
	$('#userArea, .user-area-trigger, .user-area-action').click(function() {
		$('.user-sidebox').toggleClass('open-sidebox');
		$('.backdrop').toggleClass('open-backdrop');
	});
	
	closeUserArea = function(){	
		$('.user-sidebox').removeClass('open-sidebox');
		$('.backdrop').removeClass('open-backdrop');
	}

	// Avaliaçoes do produto
	$('#avlPdt').click(function() {
		$('.avl-sidebox').toggleClass('open-sidebox');
		$('.backdrop').toggleClass('open-backdrop');
	});
	
	closeAvlPdt = function(){	
		$('.avl-sidebox').removeClass('open-sidebox');
		$('.backdrop').removeClass('open-backdrop');
	}
	
	// Dúvidas do produto
	$('#duvidasPdt').click(function() {
		$('.duvidas-sidebox').toggleClass('open-sidebox');
		$('.backdrop').toggleClass('open-backdrop');
	});
	
	closeDuvidas = function(){	
		$('.duvidas-sidebox').removeClass('open-sidebox');
		$('.backdrop').removeClass('open-backdrop');
	}
		
	// Backdrop
	$('.backdrop').click(function() {
		if( $('#buscaTopo').hasClass('abre-busca') ){
			$('#buscaTopo').removeClass('abre-busca');
			$('.backdrop').removeClass('open-backdrop');
	    }
		$(this).removeClass('open-backdrop');
		$('.cart').removeClass('open-sidebox');
		$('.col-esq').removeClass('abre-filtros');
		$('.call-sidebox').removeClass('open-sidebox');
		$('.user-sidebox').removeClass('open-sidebox');
		$('.avl-sidebox').removeClass('open-sidebox');
		$('.duvidas-sidebox').removeClass('open-sidebox');
		$('.frete-sidebox').removeClass('open-sidebox');
		$('.smart-checkout-sidebox').removeClass('open-sidebox');
	});
	
	// Aparece resumo do produto
    var product = $(".pdt-floating-price");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();
        var pScroll = 400;

        if (scroll >= pScroll) {
            product.addClass("show-fp");
        } else {
            product.removeClass("show-fp");
        }
	});
	
	// anchor scroll
	$('.scroll-to-top').click(function(){
		$('html, body').animate({
			scrollTop: $( $(this).attr('href') ).offset().top - 120
		}, 500);
		return false;
	});
	
	// Header flutuante
	var didScroll;
	var lastScrollTop = 0;
	var delta = 5;
	var navbarHeight = $('.hd-to-float').outerHeight();
	var header = $(".hd-to-float");
	
	$(window).scroll(function(event){
	    didScroll = true;
	});
	
	setInterval(function() {
	    if (didScroll) {
	        hasScrolled();
	        didScroll = false;
	    }
	}, 0);
	
	function hasScrolled() {
	    var st = $(this).scrollTop();
	    
	    // Make sure they scroll more than delta
	    if(Math.abs(lastScrollTop - st) <= delta)
	        return;
	    
	    // If they scrolled down and are past the navbar, add class .nav-up.
	    // This is necessary so you never see what is "behind" the navbar.
	    if (st > lastScrollTop && st > navbarHeight){
	        // Scroll Down
	        header.addClass("hd-floating");
	    } else {
	        // Scroll Up
	        if(st + $(window).height() < $(document).height()) {
	            header.removeClass("hd-floating");
	        }
	    }
	    
	    lastScrollTop = st;
	}
	
	/* autoclear function for inputs */
	$('.autoclear').click(function() {
		if (this.value == this.defaultValue) {
			this.value = '';
		}
	});

	$('.autoclear').blur(function() {
		if (this.value == '') {
			this.value = this.defaultValue;
		}
	});
		
	/* LEFT SIDE Search */
	$('#button-search').bind('click', function() {
		url = $('base').attr('href') + 'index.php?spsr=product/search';
		
		url += "&" + $(".side_search").find(':input[name=\'filter_name\']'+
			',:input[name=\'filter_category_id\']'+
			',:input[name=\'filter_sub_category\']'+
			',:input[name=\'filter_description\']'
		).serialize();
		
		location = url;
	});
	$('.side_search :input[name=\'filter_name\']').keydown(function(e) {
		if (e.keyCode == 13) {
			$('.side_search #button-search').click();
		}
	});
	$('.side_search input[name=\'filter_name\']').keydown(
	function(e) 
	{
		if(e.which == 13)
		{
			url = $('base').attr('href') + 'index.php?spsr=product/search';
			 
			var filter_name = $('input[name=\'filter_name\']').val()
			
			if (filter_name) 
				url += '&filter_name=' + encodeURIComponent(filter_name);
			
			location = url;
			return false;
		}	

	});
	/* TOP SEARCH */
	$('.button-search').bind('click', function() {
		url = $('base').attr('href') + 'index.php?spsr=product/search';
				 
		var filter_name = $('input[name=\'filter_name\']').val()
		
		if (filter_name) {
			url += '&filter_name=' + encodeURIComponent(filter_name);
		}
		
		location = url;
	});
	
	var cache = {}, lastXhr;
	var timer;	
	$('.autoCompleteTop').keyup(
	function(e)
	{
	   autoComplete(e, $(this), $('#suggestions'));
	});
	$('.autoCompleteBottom').keyup(
	function(e)
	{
	   autoComplete(e, $(this), $('#suggestions2'));
	});
	
	function autoComplete(e, btn, suggestions)
	{
	   var inputString = btn.val();
	   if(inputString.length == 0) 
	   {
	      	suggestions.fadeOut(); // Hide the suggestions box
	   } else 
	   {
	   		//Navigation
	   		//Down
		   	if(e.which == 40)
		   	{
		   		
		   		if(suggestions.find('ul.searchresults li.item a.selected').length == 0)
		   			suggestions.find('ul.searchresults li.item').first().find('a').addClass('selected');
		   		else
		   		{
		   			var selected = suggestions.find('ul.searchresults li.item a.selected');
		   			if(selected.parent().is(suggestions.find('ul.searchresults li.item').last()))
		   			{
		   				suggestions.find('ul.searchresults li.item').first().find('a').addClass('selected');
		   			} else
		   			{
		   				selected.parent() // moves up to the li element
		   					.next()   // moves to the adjacent li element
		   					.find('a')// moves down to the link
		   					.addClass('selected');
		   			}
		   			selected.removeClass('selected');
		   		}
		   			
		   	//Up			
		   	} else if(e.which == 38)
		   	{
		   		if(suggestions.find('ul.searchresults li.item a.selected').length == 0)
		   			suggestions.find('ul.searchresults li.item').first().find('a').addClass('selected');
		   		else
		   		{
		   			//Se ja estiver no primeiro remove o menu;
		   			
		   			var selected = suggestions.find('ul.searchresults li.item a.selected');
		   			if(selected.parent().is(suggestions.find('ul.searchresults li.item').first()))
		   			{
		   				suggestions.find('ul.searchresults li.item').last().find('a').addClass('selected');
		   			} else
		   			{
		   				selected.parent() // moves up to the li element
		   					.prev()   // moves to the adjacent li element
		   					.find('a')// moves down to the link
		   					.addClass('selected');
		   			}
		   			selected.removeClass('selected');
		   			
		   		}
		  	//Enter 	
		   	} else if(e.which == 13)
		   	{
		   		if(suggestions.find('ul.searchresults li.item a.selected').length > 0)
				{
					var loc =  suggestions.find('ul.searchresults li.item a.selected').attr('href')
					location = loc;
					
				}else
		   		{
		   			/* url = suggestions.find('base').attr('href') + 'index.php?spsr=product/search'; */
					
					url = 'index.php?spsr=product/search';
					if (inputString) {
						url += '&filter_name=' + encodeURIComponent(inputString);
					}
					
					location = url;
		   		}
		   			
		   	} else
		   	{
		   		
		   		if(inputString.length > 2 )
		   		{
		   			var term = inputString
					if ( term in cache ) {
		 				autoCompleteResponse( cache[ term ] , suggestions);
						return;
					}
					
					clearTimeout(timer);
					timer =   setTimeout(function()
										{
											lastXhr = $.post( "index.php?spsr=product/product/autocomplete&queryString=" + inputString, null, 
											function( data, status, xhr ) 
											{
												cache[ term ] = data;
												
												if ( xhr === lastXhr ) {
													autoCompleteResponse( data , suggestions);
												}
											});
										}, 600);
					
		   		}
		   		
		   	}
	   }
	}
	function autoCompleteResponse(data, suggestions)
	{
		var obj = jQuery.parseJSON(data);
	  	if(obj.length > 0)
	  	{
	  		var html = '<ul class="searchresults">';
	  		var item;
	  	  	for(item in obj)
	  	  	{
	  	  		html += '<li class="item"><a href="index.php?spsr=product/product&product_id='+obj[item].product_id+'"><img src="'+obj[item].image+'" alt="" /><div class="searchheading"><p>'+obj[item].name + '</p>';
	  	  	
				//html += '<span class="newprice">' + obj[item].price +'</span>';
	  	  		html += '</div></a></li>';
	  	  	}	
	  	  		
	
	  	  	html += '<li class="spliter"><a href="index.php?spsr=product/search&filter_name='+$('input[name=filter_name]').val()+'" title="Resultados">Ver todos resultados <span class="icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024"><path d="M921.021 527.059L441.39 982.968c-6.028 5.73-6.27 15.262-.54 21.29s15.262 6.27 21.29.54l512-486.676c6.288-5.977 6.238-16.018-.109-21.932l-512-477.088c-6.085-5.67-15.613-5.333-21.283.751s-5.333 15.613.751 21.283L930.66 496.942H52.856c-8.317 0-15.059 6.742-15.059 15.059s6.742 15.059 15.059 15.059h868.166z"/></svg></span></a></li></ul>';
	        suggestions.fadeIn(); // Show the suggestions box
	       	suggestions.html(html); // Fill the suggestions box
	  	} else
	  	{
	  		suggestions.fadeOut();
	  		suggestions.html('');
	  	}
	}	
	
	/* Ajax Cart */
	$('#cart, #cart-trigger').click(function() {
		
		$.ajax({
			url: 'index.php?spsr=checkout/cart/update',
			dataType: 'json',
			success: function(json) {
				if (json['output']) {
					$('#cartContent').html(json['output']);
				}
				
				if (json['login-area']) {
					$('#login_topo').html(json['login-area']);
					var address = $("#address_topo");
					$("#login_topo").append(address)
				}
				
				if (json != null && json['total']) {
					$('#cart_total').html(json['total']);
				}
			}
		});			
		
	});

	atualizarCarregamento();

});


function addToCart(product_id,quantity=1) {
	$.ajax({
		url: 'index.php?spsr=checkout/cart/update',
		type: 'post',
		data: 'product_id=' + product_id +'&quantity='+quantity,
		dataType: 'json',
		success: function(json) {
			$('.alert-success, .alert-warning, .alert-attention, .alert-information, .alert-error').remove();
			
			if (json['redirect']) {
				location = json['redirect'];
			}
			
			if (json['error']) {
				if (json['error']['warning']) {
					$('#ModalAlertCart').modal('show');
					$('#notification').html('<div>' + json['error']['warning'] + '</div>');
					
					$('.warning').fadeIn('slow');
					
					//$('html, body').animate({ scrollTop: 0 }, '1000');
				}
			}	 
						
			if (json['success']) {
				$('#ModalAlertCart').modal('show');
				$('#notification').html('<div style="margin-bottom: 12px;">' + json['success'] + '</div>');
				
				$('.alert-success').fadeIn('slow');
				
				if (json != null && json['total']) {
					$('#cart_total').html(json['total']);
				}
				
				//$('html, body').animate({ scrollTop: 0 }, '1000'); 
			}
			
			if (json['login-area']) {
				var address = $("#address_topo");
				var loginTopo = $('#login_topo')
				loginTopo.html(json['login-area']);
				var user = loginTopo.find('.usuario')
				user.append(address)
			}
			
			
		}
	});
}


function removeCart(key) {
	$.ajax({
		url: 'index.php?spsr=checkout/cart/update',
		type: 'post',
		data: 'remove=' + key,
		dataType: 'json',
		success: function(json) {
			$('.alert-success, .alert-warning, .alert-attention, .alert-information').remove();
			
			if (json != null && json['output']) {
				$('#cartContent').html(json['output']);
			}
			if (json != null && json['total']) {
				$('#cart_total').html(json['total']);
			}
			
			if (json['login-area']) {
				$('.login-area').html(json['login-area']);
			}
				
		}
	});
}

function removeVoucher(key) {
	$.ajax({
		url: 'index.php?spsr=checkout/cart/update',
		type: 'post',
		data: 'voucher=' + key,
		dataType: 'json',
		success: function(json) {
			$('.alert-success, .alert-warning, .alert-attention, .alert-information').remove();
			
			if (json != null && json['output']) {
				$('#cartContent').html(json['output']);
			}
			if (json != null && json['total']) {
				$('#cart_total').html(json['total']);
			}
			
			if (json['login-area']) {
				$('.login-area').html(json['login-area']);
			}
			
		}
	});
}

function addToWishList(product_id) {
	$.ajax({
		url: 'index.php?spsr=account/wishlist/update',
		type: 'post',
		data: 'product_id=' + product_id,
		dataType: 'json',
		success: function(json) {
			$('.alert-success, .alert-warning, .alert-attention, .alert-information').remove();
						
			if (json['success']) {
				$('#ModalAlertas').modal('show');
				$('#AlertText').html('<svg class="container_heart" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><path class="heart" d="M37.469252,0 C32.5412078,0 28.0882321,2.58226138 26.0169333,6.60450826 C23.9435231,2.58226138 19.4356506,0 14.5076064,0 C6.8072734,0 -3.51966072,6.20756211 1.18246201,23.1453387 C6.55601493,39.6967263 26.0148219,49.4345754 26.0148219,49.4303526 C26.0148219,49.4345754 45.4461804,39.7030605 50.8197333,23.1453387 C55.5218561,6.20756211 45.1674736,0 37.469252,0 Z" fill="none"></path></svg><div>' + json['success'] + '</div>');
				$('#wishlist_total').html(json['total']);		
			}	
		}
	});
}

function addToCompare(product_id) { 
	$.ajax({
		url: 'index.php?spsr=product/compare/update',
		type: 'post',
		data: 'product_id=' + product_id,
		dataType: 'json',
		success: function(json) {
			$('.alert-success, .alert-warning, .alert-attention, .alert-information').remove();
						
			if (json['success']) {
				$('#ModalAlertas').modal('show');
				$('#AlertText').html('<svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52"><circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/><path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/></svg><div>' + json['success'] + '</div>');
				$('#compare_total').html(json['total']);
			}	
		}
	});
}

jQuery.fn.center = function () 
{
	this.css("position","fixed");
	this.css("top", Math.max(0, (($(this).parent().height() - this.outerHeight()) / 2) +  $(this).parent().scrollTop()) + "px");
	this.css("left", Math.max(0, (($(this).parent().width() - this.outerWidth()) / 2) +   $(this).parent().scrollLeft()) + "px");
	return this;
}
function scrollToElement(jElem) {
	$('html, body').animate({
		scrollTop: jElem.offset().top - 10
	}, 1000);
}				
function showLoading(carrega, funcao, txt)
{	
	var msg = 'Carregando...';
	if(txt)
		msg = txt;
	if(carrega)
	{
    $("#loading .txt").html(msg);
		$('#loading').fadeIn(funcao);
	} else
	{
		$('#loading').fadeOut(funcao);
	}
}
function verificaCNPJ(str) {
    str = str.replace('.','');
    str = str.replace('.','');
    str = str.replace('.','');
    str = str.replace('-','');
    str = str.replace('/','');
    cnpj = str;
    var numeros, digitos, soma, i, resultado, pos, tamanho, digitos_iguais;
    digitos_iguais = 1;
    if (cnpj.length < 14 && cnpj.length < 15)
        return false;
    for (i = 0; i < cnpj.length - 1; i++)
        if (cnpj.charAt(i) != cnpj.charAt(i + 1))
    {
        digitos_iguais = 0;
        break;
    }
    if (!digitos_iguais)
    {
        tamanho = cnpj.length - 2
        numeros = cnpj.substring(0,tamanho);
        digitos = cnpj.substring(tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--)
        {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(0))
            return false;
        tamanho = tamanho + 1;
        numeros = cnpj.substring(0,tamanho);
        soma = 0;
        pos = tamanho - 7;
        for (i = tamanho; i >= 1; i--)
        {
            soma += numeros.charAt(tamanho - i) * pos--;
            if (pos < 2)
                pos = 9;
        }
        resultado = soma % 11 < 2 ? 0 : 11 - soma % 11;
        if (resultado != digitos.charAt(1))
            return false;
        return true;
    }
    else
        return false;
}
function verificaCPF (cpf) 
{
    if(cpf.length > 11) cpf = cpf.replace(".",""); 
    if(cpf.length > 11) cpf = cpf.replace(".",""); 
    if(cpf.length > 11) cpf = cpf.replace("-","");

    if( cpf == "00000000011" ) return true;

    if (cpf.length != 11 || cpf == "00000000000" || cpf == "11111111111" || cpf == "22222222222" || cpf == "33333333333" || cpf == "44444444444" || cpf == "55555555555" || cpf == "66666666666" || cpf == "77777777777" || cpf == "88888888888" || cpf == "99999999999") return false;

    var add = 0;
    for (i=0; i < 9; i ++) add += parseInt(cpf.charAt(i)) * (10 - i);
   
    rev = 11 - (add % 11);
    
    if (rev == 10 || rev == 11) rev = 0;
    
    if (rev != parseInt(cpf.charAt(9))) return false;
    
    add = 0;
    for (i = 0; i < 10; i ++)  add += parseInt(cpf.charAt(i)) * (11 - i);
    
    rev = 11 - (add % 11);
    if (rev == 10 || rev == 11)  rev = 0;

    return rev == parseInt(cpf.charAt(10));
}



function atualizarCarregamento(){
	
	$.ajax({
		url: 'index.php?spsr=checkout/cart/update',
		dataType: 'json',
		success: function(json) {
			if (json['output']) {
				$('#cartContent').html(json['output']);
			}
			if (json['login-area']) {
				$('.login-area').html(json['login-area']);
			}
			
			if (json['cart-area']) {
				$('#cart_total').html(json['cart-area']);
			}
		}
	});	
	
}